import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const swalCrm = {
  customClass: {
    popup: "swal-crm-popup",
    title: "swal-crm-title",
    htmlContainer: "swal-crm-html",
    confirmButton: "swal-crm-confirm",
  },
};

const VALID_COMPANIES = ["CHF", "SKD", "WIBOR", "SLUZEBNOSC"];

const ImportLeadSend = (props) => {
  const [loading, setLoading] = useState(true);
  const [array, setArray] = useState([]);
  const [arrayNon, setArrayNon] = useState([]);
  const [fileInfo, setFileInfo] = useState({});

  const fileReader = new FileReader();

  const fetchLeadsImport = async () => {
    await fetch("https://apiftpsplit.ftpeople.pl/importLeadsSend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify({ leads: array }),
    })
      .then((response) => response.text())
      .then(() => {
        MySwal.fire({
          icon: "success",
          title: "Zaimportowano",
          text: "leady do wysyłki",
          ...swalCrm,
        }).then(() => props.close());
      })
      .catch(() => {});
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  const importLead = () => {
    if (array.length > 0) {
      setLoading(true);
      fetchLeadsImport();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wgraj",
        text: "prawidłowy plik",
        ...swalCrm,
      });
    }
  };

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

    const array1 = [];
    const arrayN = [];

    csvRows.forEach((i) => {
      const values = i.split(";");
      const company = values[3]?.trim() ?? "";
      const row = {
        name: values[0],
        phone: values[1],
        mail: values[2],
        source: "SEND MANUAL",
        company,
      };

      if (VALID_COMPANIES.includes(company)) {
        array1.push(row);
      } else if (values.length !== 1) {
        arrayN.push(row);
      }
    });

    setFileInfo({
      rows: csvRows.filter(
        (i) => i.split(";")[3] !== undefined && i.split(";")[3] !== ""
      ).length,
      rowsAcc: array1.length,
    });
    setArray(array1);
    setArrayNon(arrayN);
    setLoading(false);
  };

  const readFile = (e) => {
    if (e.target.files[0]) {
      e.preventDefault();
      setLoading(true);
      fileReader.onload = (event) => csvFileToArray(event.target.result);
      fileReader.readAsText(e.target.files[0], "Windows-1250");
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
        ...swalCrm,
      });
    }
  };

  const exportArrayNon = () => {
    const header = ["name", "phone", "mail", "source", "company"];
    const body = arrayNon.map((el) => [
      el.name,
      el.phone,
      el.mail,
      el.source,
      el.company,
    ]);
    downloadExcel({
      fileName: "importNon_report_" + new Date(),
      sheet: "data",
      tablePayload: { header, body },
    });
  };

  return (
    <div className="il-overlay">
      <div className="il-panel">
        {loading ? (
          <Loading />
        ) : (
          <>
            {/* Header */}
            <div className="il-header">
              <div className="il-header-left">
                <div
                  className="sidebar-logo"
                  style={{ width: 40, height: 40, fontSize: 17 }}
                >
                  IL
                </div>
                <div>
                  <h2 className="il-title">Importuj Leady do Wysyłki</h2>
                  <a
                    className="il-example-link"
                    href="https://ftpeople.pl/wp-content/uploads/2025/03/lead_splitter_example-1-1_send.csv"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Pobierz przykładowy plik CSV →
                  </a>
                </div>
              </div>
              <button
                className="ld-close"
                onClick={props.close}
                title="Zamknij"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="il-body">
              {/* Dozwolone spółki */}
              <div className="adm-desc">
                Dozwolone wartości kolumny <strong>company</strong>:{" "}
                {VALID_COMPANIES.map((c) => (
                  <strong key={c} style={{ marginRight: 6 }}>
                    {c}
                  </strong>
                ))}
              </div>

              {/* Upload zone */}
              <div className="rp-section">
                <span className="rp-section-label">Plik CSV</span>
                <label className="af-drop-zone">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  Kliknij lub przeciągnij plik
                  <input
                    className="af-file-input"
                    type="file"
                    accept=".csv"
                    onChange={readFile}
                  />
                </label>
              </div>

              {/* Stats */}
              <div className="il-stats">
                <div className="il-stat">
                  <span className="il-stat-label">Wszystkich rekordów</span>
                  <span className="il-stat-value">{fileInfo.rows ?? 0}</span>
                </div>
                <div className="il-stat il-stat--ok">
                  <span className="il-stat-label">Prawidłowych</span>
                  <span className="il-stat-value il-stat-value--ok">
                    {fileInfo.rowsAcc ?? 0}
                  </span>
                </div>
                {arrayNon.length > 0 && (
                  <div className="il-stat il-stat--err">
                    <span className="il-stat-label">Nieprawidłowych</span>
                    <span className="il-stat-value il-stat-value--err">
                      {arrayNon.length}
                    </span>
                  </div>
                )}
              </div>

              {/* Download invalid */}
              {arrayNon.length > 0 && (
                <button
                  className="lq-btn lq-btn--muted il-export-btn"
                  onClick={exportArrayNon}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  Pobierz nieprawidłowe ({arrayNon.length})
                </button>
              )}
            </div>

            {/* Footer */}
            <div className="il-footer">
              <button className="lq-btn lq-btn--muted" onClick={props.close}>
                Anuluj
              </button>
              <button
                className="lq-btn lq-btn--primary"
                onClick={importLead}
                disabled={array.length === 0}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                >
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" />
                  <line x1="12" y1="3" x2="12" y2="15" />
                </svg>
                Importuj {array.length > 0 ? `(${array.length})` : ""}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ImportLeadSend;
